const URL_BASE=process.env.REACT_APP_API;

export const URL_PACKS=`${URL_BASE}/content/packs/list`;
//export const URL_EDIT_PACKS=`${URL_BASE}/content/packs/edit`;
